import type { SessionConfig } from '@xing-com/crate-xinglet/internal';

import type { ConfigureRequest } from '../types';

export function configureRequestWithAcceptLanguageHeader(
  sessionConfig: SessionConfig
): ConfigureRequest {
  return (request) => {
    const { language } = sessionConfig;

    request.headers.set('Accept-Language', language);

    return request;
  };
}
